import React from 'react';
import { Route, Navigate, Routes, HashRouter as DOMRouter } from 'react-router-dom';

import AirchainAPI from './utils/airchain-api';
import Views from './views';

export default function Router(props) {
	// Settings has two audiences. The System sections (core config, logs,
	// ffmpeg internals) are for operators only -- the header hides the link and
	// this stops a typed URL from rendering a screen whose every request the
	// core rejects for tenant users. The Team section is account-wide membership,
	// which is the tenant's own business, so an owner or member reaches the same
	// screen and Settings renders the one section they are allowed to see.
	const isOperator = props.restreamer !== null && props.restreamer.IsOperator();
	const [$role, setRole] = React.useState(null);

	React.useEffect(() => {
		if (props.restreamer === null || isOperator) {
			return;
		}
		let live = true;
		(async () => {
			try {
				const team = await AirchainAPI.GetMembers(props.restreamer.GetAccessToken());
				if (live) {
					setRole(team && team.me ? team.me.role : 'none');
				}
			} catch (error) {
				// no token, or not a member of this instance: send them back
				if (live) {
					setRole('none');
				}
			}
		})();
		return () => {
			live = false;
		};
	}, [props.restreamer, isOperator]);

	if (props.restreamer === null) {
		return null;
	}

	const channelid = props.restreamer.GetCurrentChannelID();

	// While the role is unknown, render nothing rather than bouncing to the
	// channel list -- a member who followed a link would be thrown out and then
	// have to find their way back. A lookup that came back negative is 'none',
	// which does redirect.
	const allowed = isOperator || $role === 'owner' || $role === 'member';
	const pending = !isOperator && $role === null;
	const settings = allowed ? (
		<Views.Settings restreamer={props.restreamer} />
	) : pending ? null : (
		<Navigate to="/" replace />
	);

	return (
		<DOMRouter>
			<Routes>
				<Route path="/" element={<Views.ChannelSelect channelid={channelid} />} />
				<Route path="/playersite" element={<Views.Playersite restreamer={props.restreamer} />} />
				<Route path="/settings" element={settings} />
				<Route path="/settings/:tab" element={settings} />
				<Route path="/:channelid" element={<Views.Main key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/edit" element={<Views.Edit key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/edit/wizard" element={<Views.Wizard key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/edit/:tab" element={<Views.Edit key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/publication" element={<Views.AddService key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/publication/player" element={<Views.EditPlayer key={channelid} restreamer={props.restreamer} />} />
				<Route path="/:channelid/publication/:service/:index" element={<Views.EditService key={channelid} restreamer={props.restreamer} />} />
				<Route path="*" render={() => <Navigate to="/" replace />} />
			</Routes>
		</DOMRouter>
	);
}

Router.defaultProps = {
	restreamer: null,
};
